import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const useNationalCommitteesStore = defineStore('nationalCommitteesStore', {
  state: () => ({
    endpoint: 'national-committees',
    ...defaultState
  }),
  actions: {
    ...defaultActions
  }
})
